import { Profile, ProfileConfig } from '@foxcorp/foxkit-profile-js';

import { configOptions } from '@/sdk/shared/profileOptions';

import { statefulRefreshToken } from './statefulRefreshToken';

const profileConfig = new ProfileConfig({
  ...configOptions,

  useEksEndPoints: true,

  statefulRefreshToken,
});

export const profileSDK = new Profile(profileConfig);
